export const getProductPriceUnitLabel = (backendUnit) => getUnitLabel(backendUnit, "kg_l");

export const getUnitLabel = (backendUnit, unitMeasurement) => {
	if (backendUnit === "u") {
		return "Un";
	}

	if (backendUnit === "g") {
		switch (unitMeasurement) {
			case "kg_l":
				return "Kg";
			case "ton_kl":
				return "Ton";
			case "gr_cc":
			default:
				return "g";
		}
	}

	if (backendUnit === "cc") {
		switch (unitMeasurement) {
			case "kg_l":
				return "L";
			case "ton_kl":
				return "KL";
			case "gr_cc":
			default:
				return "cc";
		}
	}

	return "Kg";
};
